<template>
  <section>
    <!--工具条-->
    <LineManVehicleToolbar :buttonList="buttonList" @callFunction="callFunction"></LineManVehicleToolbar>

    <!--列表-->
    <el-table
      :data="lineManVehicleList"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        fixed="left"
        label="操作"
        width="130">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide && scope.row.IsBind === true && (item.name === '取消绑定' || item.name === '编辑')" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="LineName" label="线路名称" width="130"></el-table-column>
      <el-table-column prop="ShiftsQuantity" label="班次数量" width="130"></el-table-column>
      <el-table-column prop="DriversQuantity" label="司机数量" width="100"></el-table-column>
      <el-table-column
        label="司机明细"
        width="320">
        <template slot-scope="scope">
          <span v-for="item in scope.row.VehicleLine" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" @click="handleDriverEdit(item)">{{item.DriverName}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="VehicleQuantity" label="车辆数" width="100"></el-table-column>
      <el-table-column
        label="车辆明细"
        width="350">
        <template slot-scope="scope">
          <span v-for="item in scope.row.VehicleLine" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" @click="handleVehicleEdit(item)">{{item.LicensePlateNumber}}</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑绑定-->
    <el-dialog
      title="编辑绑定"
      :visible.sync="bindingFormVisibleEdit"
      v-model="bindingFormVisibleEdit"
      :close-on-click-modal="false"
      width="65%"
    >
      <el-form :model="bindingFormEdit" label-width="80px" ref="bindingFormEdit">
        <el-row>
          <el-col :span="8">
            <el-form-item label="线路名称" prop="LineName" label-width="110px">
              <el-input v-model="bindingFormEdit.LineName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="绑定" label-width="110px">
            <el-col :span="11">
                <el-table
                  ref="unBindingTableEdit"
                  v-loading="bindingListLoadingEdit"
                  :key="tableKey"
                  :data="vehicleUnboundListEdit"
                  border
                  fit
                  highlight-current-row
                  @selection-change="handleBindingChangeEdit"
                  :row-key="getRowKeys" 
                  max-height="450"
              >
              <el-table-column label="待绑信息">
                <el-table-column>
                  <template slot="header" slot-scope="{row}">
                    <el-input
                      v-model="leftLicensePlateNumberEdit"
                      size="mini"
                      placeholder="请输入车牌"
                      v-on:input="leftLicensePlateNumberChangeEdit"
                      @change="((val)=>{inputChange(val, row)})"
                      ></el-input>
                  </template>
                  <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
                    <el-table-column label="车牌" align="center">
                      <template slot-scope="{row}">
                        <span>{{ row.LicensePlateNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="司机" align="center">
                      <template slot-scope="scope">
                        <el-select style="width: 100%;" @change="((val)=>{driverChangeEdit(val, scope.row.Id)})" v-model="scope.row.DriverId" filterable placeholder="请选择司机">
                          <el-option
                            v-for="item in driverList"
                            :key="item.Id"
                            :value="item.Id"
                            :label="item.Name"
                            >
                            <span style="float: left">{{ item.Name }}</span>
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="2" style="text-align:center;">
              <el-button
                @click="addBindingEdit"
                type="primary"
                :disabled="!bindingDataEdit.length"
                icon="el-icon-arrow-right"
                circle
              ></el-button>
              <el-button
                @click="removeBindingEdit"
                type="primary"
                :disabled="!selectedBindingDataEdit.length"
                icon="el-icon-arrow-left"
                circle
                style="margin-left: 0;margin-top: 10px;"
              ></el-button>
            </el-col>
            <el-col :span="11">
              <el-table
                ref="selectedBindingTableEdit"
                v-loading="rightBindingListLoadingEdit"
                :key="tableKey"
                :data="selectedBindingListEdit"
                border
                fit
                highlight-current-row
                @selection-change="handleSelectedBindingChangeEdit"
                :row-key="getRowKeys" 
                max-height="450"
              >
                <el-table-column label="已绑信息">
                  <el-table-column>
                    <template slot="header" slot-scope="{row}">
                      <el-input
                        v-model="rightLicensePlateNumberEdit"
                        size="mini"
                        v-on:input="rightLicensePlateNumberChangeEdit"
                        @change="((val)=>{inputChange(val, row)})"
                        placeholder="请输入车牌或司机"/>
                    </template>
                    <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
                    <el-table-column label="车牌" align="center">
                      <template slot-scope="{row}">
                        <span>{{ row.LicensePlateNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="司机" align="center">
                      <template slot-scope="{row}">
                        <span>{{ row.DriverName }}</span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="bindingFormVisibleEdit = false">取消</el-button>
        <el-button type="primary" @click.native="editBindingSubmit" :loading="bindingLoadingEdit">提交</el-button>
      </div>
    </el-dialog>

    <!--修改司机-->
    <el-dialog
      title="修改司机"
      :visible.sync="editDriverFormVisible"
      v-model="editDriverFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="editDriverForm" label-width="80px" :rules="editDriverFormRules" ref="editDriverForm">
        <el-row>
          <el-form-item label="司机姓名" prop="DriverId" label-width="110px">
            <el-select style="width: 100%;" v-model="editDriverForm.DriverId" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in driverList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车辆信息" prop="LicensePlateNumber" label-width="110px">
            <el-input v-model="editDriverForm.LicensePlateNumber" :disabled="true" />
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editDriverFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editDriverSubmit" :loading="editDriverLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--修改车辆-->
    <el-dialog
      title="修改车辆"
      :visible.sync="editVehicleFormVisible"
      v-model="editVehicleFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="editVehicleForm" label-width="80px" :rules="editVehicleFormRules" ref="editVehicleForm">
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="editVehicleForm.VehicleId" filterable placeholder="请选择车牌号">
                <el-option
                  v-for="item in vehicleList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LicensePlateNumber"
                >
                  <span style="float: left">{{ item.LicensePlateNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="司机姓名" prop="DriverName" label-width="110px">
            <el-input v-model="editVehicleForm.DriverName" :disabled="true" />
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editVehicleFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editVehicleSubmit" :loading="editVehicleLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getLineManVehicleListPage,putEditBindingVehiclesList,cancelLineManVehicleBinding,getDriverListPage,getVehiclesListPage,editVehicleLineDriver,editVehicleLineVehicle,exportExcel } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import LineManVehicleToolbar from "../../components/QueryToolbar/LineManVehicleToolbar";

export default {
  components: { LineManVehicleToolbar },
  data() {
    return {
      filters: {
        busLinesId: "",
        driverId: "",
        vehicleId: ""
      },
      buttonList: [],
      operationButtonList: [],
      lineManVehicleList: [], //线路人车绑定列表
      driverList: [], //驾驶员列表
      vehicleList: [], //车辆列表
      vehicleUnboundListEdit: [], //待绑列表(编辑)
      bindingDataEdit : [], //已选需要绑定的数据(编辑)
      selectedBindingDataEdit : [], //已选需要解绑的数据(编辑)
      selectedBindingListEdit: [], //已绑定列表(编辑)
      selectedBindingBackupListEdit: [], //已绑定备份列表(编辑)
      tableKey: 0,
      rightBindingListLoadingEdit: false, //右边待绑列表加载(编辑)
      bindingListLoadingEdit: true, //待绑列表加载(编辑)
      leftLicensePlateNumberEdit:"", //左边过滤输入框(编辑)
      rightLicensePlateNumberEdit:"", //右边过滤输入框(编辑)
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      operatingStatusList: [
        { name: "营运", value: true },
        { name: "停运", value: false }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      bindingFormVisibleEdit: false, //编辑绑定界面是否显示
      bindingLoadingEdit: false,
      //编辑绑定界面数据
      bindingFormEdit: {
        BusLinesId: 0,
        LineName: "",
        Vehicles: [] //已绑车辆列表
      },
      editDriverFormVisible: false, //修改司机界面是否显示
      editDriverLoading: false,
      editDriverFormRules: {
        DriverId: [{ required: true, message: "司机姓名不能为空", trigger: "blur" }]
      },
      //修改司机界面数据
      editDriverForm: {
        Id: 0,
        CreateBy: "",
        VehicleId: 0,
        BusLinesId: 0,
        DriverId: 0,
        DriverName: "",
        LicensePlateNumber: ""
      },
      editVehicleFormVisible: false, //修改车辆界面是否显示
      editVehicleLoading: false,
      editVehicleFormRules: {
        VehicleId: [{ required: true, message: "车牌号不能为空", trigger: "blur" }]
      },
      //修改车辆界面数据
      editVehicleForm: {
        Id: 0,
        CreateBy: "",
        VehicleId: 0,
        BusLinesId: 0,
        DriverId: 0,
        DriverName: "",
        LicensePlateNumber: ""
      }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    getRowKeys(row) {
      return row.Id;
    },
    callFunction(item) {
      this.filters = {
        busLinesId: item.busLinesId,
        driverId: item.driverId,
        vehicleId: item.vehicleId
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getLineManVehicle();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLineManVehicle();
    },
    queryLineManVehicle(){
      this.page = 1;
      this.getLineManVehicle();
    },
    //获取线路人车绑定列表
    getLineManVehicle() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        driverId: _this.filters.driverId,
        vehicleId: _this.filters.vehicleId,
        isBind: 'true',
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getLineManVehicleListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.lineManVehicleList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //取消绑定
    cancelBinding() {
      this.$confirm("确认取消绑定吗？", "提示", {}).then(() => {
        let para = Object.assign({}, this.currentRow);

        cancelLineManVehicleBinding(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.$emit('myevent',null);
            this.getLineManVehicle();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      });
    },
    handleDriverEdit(row) {
      this.editDriverFormVisible = true;
      this.editDriverForm = Object.assign({}, row);
    },
    handleVehicleEdit(row) {
      this.editVehicleFormVisible = true;
      this.editVehicleForm = Object.assign({}, row);
    },
    leftLicensePlateNumberChangeEdit(value){
      this.vehicleUnboundListInitEdit();
      if(value !== "" && this.vehicleUnboundListEdit.length > 0){
        this.vehicleUnboundListEdit = this.vehicleUnboundListEdit.filter(it=>it.LicensePlateNumber.indexOf(value) > -1);
      }
    },
    rightLicensePlateNumberChangeEdit(value){
      this.selectedBindingListInitEdit();
      if(value !== "" && this.selectedBindingListEdit.length > 0){
        this.selectedBindingListEdit = this.selectedBindingListEdit.filter(it=>it.LicensePlateNumber.indexOf(value) > -1 || (it.DriverName !== "" && it.DriverName !== null && it.DriverName.indexOf(value) > -1));
      }
    },
    inputChange(val,Id){

    },
    //编辑绑定
    handleEditBinding(){
      this.bindingFormVisibleEdit = true;
      this.bindingFormEdit.BusLinesId = this.currentRow.BusLinesId;
      this.bindingFormEdit.LineName = this.currentRow.LineName;
      this.bindingDataEdit = []; //初始化已选需要绑定的数据
      this.selectedBindingDataEdit = []; //初始化已选需要解绑的数据
      this.selectedBindingListEdit = []; //初始化已绑定列表
      this.selectedBindingBackupListEdit = []; //初始化已绑定备份列表
      this.leftLicensePlateNumberEdit = "",
      this.rightLicensePlateNumberEdit = "",
      this.getVehiclesList();
      this.bindingListLoadingEdit=false;
    },
    driverChangeEdit(value,vehicleId){
      let driverName = this.driverList.filter(d=>d.Id === value)[0].Name;
      let vehicleUnboundFilterList = this.vehicleUnboundListEdit.filter(d=>d.Id === vehicleId);
      vehicleUnboundFilterList.forEach(item=>{
        item.DriverId = value;
        item.DriverName = driverName;
      })
    },
     // 将左边表格选择项存入bindingDataEdit中(编辑)
    handleBindingChangeEdit(rows) {
      this.bindingDataEdit = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.bindingDataEdit.push(row);
          }
        });
      }
    },
    // 将右边表格选择项存入selectedBindingDataEdit中(编辑)
    handleSelectedBindingChangeEdit(rows) {
      this.selectedBindingDataEdit = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectedBindingDataEdit.push(row);
          }
        });
      }
    },
    // 左边表格选择项移到右边(编辑)
    addBindingEdit() {
      setTimeout(() => {
        this.$refs.unBindingTableEdit.clearSelection();
        this.$refs.selectedBindingTableEdit.clearSelection();
      }, 0);
      
      this.bindingDataEdit.forEach(item => {
        item.BusLinesId = this.bindingFormEdit.BusLinesId;
        this.selectedBindingListEdit.push(item);
        this.selectedBindingBackupListEdit.push(item);
      });

      for (let i = 0; i < this.vehicleUnboundListEdit.length; i++) {
        for (let j = 0; j < this.bindingDataEdit.length; j++) {
          if (
            this.vehicleUnboundListEdit[i] &&
            this.bindingDataEdit[j] &&
            this.vehicleUnboundListEdit[i].LicensePlateNumber === this.bindingDataEdit[j].LicensePlateNumber
          ) {
            this.vehicleUnboundListEdit.splice(i, 1);
          }
        }
      }
    },
    // 右边表格选择项移到左边(编辑)
    removeBindingEdit() {
      setTimeout(() => {
        this.$refs.unBindingTableEdit.clearSelection();
        this.$refs.selectedBindingTableEdit.clearSelection();
      }, 0);

      this.selectedBindingDataEdit.forEach(item => {
        item.DriverId = 0;
        this.vehicleUnboundListEdit.push(item);
      });

      for (let i = 0; i < this.selectedBindingListEdit.length; i++) {
        for (let j = 0; j < this.selectedBindingDataEdit.length; j++) {
          if (
            this.selectedBindingListEdit[i] &&
            this.selectedBindingDataEdit[j] &&
            this.selectedBindingListEdit[i].LicensePlateNumber === this.selectedBindingDataEdit[j].LicensePlateNumber
          ) {
            this.selectedBindingListEdit.splice(i, 1);
            this.selectedBindingBackupListEdit.splice(i, 1);
          }
        }
      }
    },
    // 导出
    handleExportExcel(){
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        driverId: _this.filters.driverId,
        vehicleId: _this.filters.vehicleId,
        isBind: 'true',
        page: _this.page,
        pageSize: _this.pageSize
      };
      exportExcel(para).then(res => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        let a = document.createElement("a");
        a.href = url;
        a.download = "线路人车绑定数据(已绑定).xlsx";
        a.click();
        // 5.释放这个临时的对象url
        window.URL.revokeObjectURL(url);
      },
      (err) => {
        resolve(err.response);
      })
      .catch((error) => {
        reject(error);
      });
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            editCompany(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getLineManVehicle();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    // 编辑绑定提交
    editBindingSubmit:function() {
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        this.bindingLoadingEdit = true;
        if(this.selectedBindingListEdit.length === 0){
          this.$message({
            message: "请选择待绑数据",
            type: "error"
          });
          this.bindingLoadingEdit = false;
          return;
        }
        this.bindingFormEdit.Vehicles = this.selectedBindingListEdit;
        let para = Object.assign({}, this.bindingFormEdit);
        putEditBindingVehiclesList(para).then(res => {
          if (util.isEmt.format(res)) {
            this.bindingLoadingEdit = false;
            return;
          }

          if (res.data.success) {
            this.bindingLoadingEdit = false;
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.$refs["bindingFormEdit"].resetFields();
            this.bindingFormVisibleEdit = false;
            this.$emit('myevent',null);
            this.getLineManVehicle();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      });
    },
    //编辑司机
    editDriverSubmit: function() {
      this.$refs.editDriverForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editDriverLoading = true;
            let para = Object.assign({}, this.editDriverForm);

            editVehicleLineDriver(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editDriverLoading = false;
                return;
              }

              if (res.data.success) {
                this.editDriverLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editDriverForm"].resetFields();
                this.editDriverFormVisible = false;
                this.getLineManVehicle();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //编辑车辆
    editVehicleSubmit: function() {
      this.$refs.editVehicleForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editVehicleLoading = true;
            let para = Object.assign({}, this.editVehicleForm);

            editVehicleLineVehicle(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editVehicleLoading = false;
                return;
              }

              if (res.data.success) {
                this.editVehicleLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editVehicleForm"].resetFields();
                this.editVehicleFormVisible = false;
                this.getLineManVehicle();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    },
    getDriverList(){
      let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
      getDriverListPage(driverPara).then(res => {
        this.driverList = res.data.response.data;
      });
    },
    getVehiclesList(){
      let vehiclesPara = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: 1,
        pageSize: 200
      };
      getVehiclesListPage(vehiclesPara).then(res => {
        this.vehicleList = res.data.response.data;
        this.vehicleUnboundListInitEdit();
        this.vehicleBoundListInitEdit();
      });
    },
    vehicleUnboundListInitEdit(){
      this.vehicleUnboundListEdit=[];
      this.vehicleList.forEach(item=>{
        if(item.DriverId === 0){
          this.vehicleUnboundListEdit.push(item);
        }
      });
    },
    vehicleBoundListInitEdit(){
      this.selectedBindingListEdit=[];
      this.selectedBindingBackupListEdit=[];
      this.vehicleList.forEach(item=>{
        if(item.BusLinesId === this.bindingFormEdit.BusLinesId && item.DriverId > 0){
          this.selectedBindingListEdit.push(item);
          this.selectedBindingBackupListEdit.push(item);
        }
      });
    },
    selectedBindingListInitEdit(){
      this.selectedBindingListEdit=[];
      this.selectedBindingBackupListEdit.forEach(item=>{
        this.selectedBindingListEdit.push(item);
      });
    }
  },
  mounted() {
    this.getLineManVehicle();
    this.getDriverList();
    this.getVehiclesList();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
